import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
const ContactUsSection = () => {
  const { t } = useTranslation();

  const contactInfo = [
    {
      icon: faEnvelope,
      delay: "0.3s",
      href: "Info@almumtazalaslia.com.ly",
      value: "Info@almumtazalaslia.com.ly",
    },
    {
      icon: faPhoneAlt,
      delay: "0.4s",
      item: "218912033555+",
      href: "tel:+218913102202",
      value: <><bdo dir="ltr">+218 91-3102202</bdo>
        <br />
        <bdo dir="ltr">+218 91-5468226</bdo></>,
    },
    {
      icon: faWhatsapp,
      delay: "0.4s",
      value: <bdo dir="ltr">+218 91-3142678</bdo>,
      href: "https://wa.me/218913142678",
    },
  ];

  return (
    <div className="container-xxl contact py-5">
      <div className="container">
        <div
          className="section-title text-center mx-auto wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "500px" }}
        >
          <span className="fs-5 text-secondary fst-italic">
            {t("contact_section_title")}
          </span>
          <h1 className="fw-bold my-3 text-secondary">
            {t("contact_section_heading")}
          </h1>
        </div>
        <div
          className="row justify-content-center wow fadeInUp"
          data-wow-delay="0.1s"
        >
          <div className="col-lg-8">
            <p className="text-center mb-5">
              {t("contact_section_description")}
            </p>
            <div className="row g-5">
              {contactInfo.map((item, index) => (
                <div
                  key={index}
                  className="col-md-4 text-center wow fadeInUp"
                  data-wow-delay={item.delay}
                >
                  <div className="btn-square mx-auto mb-3">
                    <FontAwesomeIcon
                      icon={item.icon}
                      className="fa-2x text-white"
                    />
                  </div>

                  <a
                    href={item.href}
                    target="_blank"
                    rel="noreferrer"
                    className="contact-details-link p-ltr"
                  >
                    {item.value}

                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsSection;
